module.exports = __webpack_public_path__ + "static/media/info_paciente_icon3.a37abd0b.svg";